import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Experience from './pages/Experience';
import Hospital from './pages/Hospital';
import Appointment from './pages/Appointment';
import Contact from './pages/Contact';
import Certifications from './pages/Certifications';
import './styles/medical-theme.css';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import LaserKidneyStone from './pages/treatments/LaserKidneyStone';
import LaparoscopicUrology from './pages/treatments/LaparoscopicUrology';
import EndourologyTreatment from './pages/treatments/EndourologyTreatment';
import ProstateEnlargement from './pages/treatments/ProstateEnlargement';
import UrologicOncology from './pages/treatments/UrologicOncology';
import UTI from './pages/treatments/UtiTreatment';
import MaleInfertility from './pages/treatments/MaleInfertility';
import ErectileDysfunction from './pages/treatments/ErectileDysfunction';
import BladderProblems from './pages/treatments/BladderProblems';
import PediatricUrology from './pages/treatments/PediatricUrology';
import RoboticUrology from './pages/treatments/RoboticUrology';
import Andrology from './pages/treatments/AndrologyTreatment';
import FemaleUrology from './pages/treatments/FemaleUrology';
import Hemodialysis from './pages/treatments/Hemodialysis';
import Gallery from "./pages/Gallery";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/hospital" element={<Hospital />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/treatments/laser-kidney-stone" element={<LaserKidneyStone />} />
            <Route path="/treatments/laparoscopic-urology" element={<LaparoscopicUrology />} />
            <Route path="/treatments/endourology" element={<EndourologyTreatment />} />
            <Route path="/treatments/prostate-enlargement" element={<ProstateEnlargement />} />
            <Route path="/treatments/urologic-oncology" element={<UrologicOncology />} />
            <Route path="/treatments/uti" element={<UTI />} />
            <Route path="/treatments/male-infertility" element={<MaleInfertility />} />
            <Route path="/treatments/erectile-dysfunction" element={<ErectileDysfunction />} />
            <Route path="/treatments/bladder-problems" element={<BladderProblems />} />
            <Route path="/treatments/pediatric-urology" element={<PediatricUrology />} />
            <Route path="/treatments/robotic-urology" element={<RoboticUrology />} />
            <Route path="/treatments/andrology" element={<Andrology />} />
            <Route path="/treatments/female-urology" element={<FemaleUrology />} />
            <Route path="/treatments/hemodialysis-av-fistula" element={<Hemodialysis />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
          <ScrollToTopButton />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
